const ADD_TO_CART_CLASSNAME = 'blaze-ecommerce-add-to-cart';

export { ADD_TO_CART_CLASSNAME };
